declare global {
  interface Window {
    Swiper: any;
  }
}

export function initXmasFpHeroFullscreen(root: ParentNode = document): void {
  const sliders = root.querySelectorAll<HTMLElement>('.ek-fp-hero-slider');
  if (!sliders.length) return;

  if (typeof window.Swiper !== 'function') {
    setTimeout(() => initXmasFpHeroFullscreen(root), 50);
    return;
  }

  sliders.forEach((slider) => {
    if (slider.dataset.init === 'true') return;
    slider.dataset.init = 'true';

    new window.Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: Number(slider.dataset.autoplayDelay) || 2000,
        disableOnInteraction: true,
      },
      speed: 1,
      allowTouchMove: true,
    });
  });
}
